import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class SpecsFamilyProductModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Product name", fieldType: "text" },
    version: { label: "Product version", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  version!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("version", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "family product");
    this.name = readString(source, "name");
    this.version = readString(source, "version");
    this.extra = splitKnown(source, ["name", "version"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      name: this.name,
      ...(this.version ? { version: this.version } : {}),
    };
  }
}
